export enum CompanyType {
    Public = 'Public',
    Private = 'Private',
}
